import RainbowLoader from './RainbowLoader';

export default RainbowLoader;
